<template>
  <div>
    <!-- <el-select v-model="net" placeholder="请选择">
      <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
      </el-option>
    </el-select> -->
   
      <el-select v-model="queryProjectId" placeholder="请选择项目">
        <el-option
          v-for="(item, index) in projectList"
          :key="index"
          :label="item.name"
          :value="item.id"
        ></el-option>
      </el-select>
  

    <el-button type="primary" @click="jumpTo">跳 转</el-button>
  </div>
</template>

<script>
import { getProjectList } from '@/api/crmedical/project/project';
export default {
  data() {
    return {
      net: '',
      queryProjectId: '',
      projectList: [],
    };
  },
  methods: {
    jumpTo() {
      window.open('https://rpt-test.pms1.cn/webroot/decision/view/form?viewlet=xhHospitalbak.frm&'+this.queryProjectId);
    },
   
    initData() {
      getProjectList().then((res) => {
        this.projectList = res.data;
        console.log(this.projectList);
      });
    },
  },
  created() {
      this.initData()
  },
};
</script>